import { Link } from "react-router-dom";
import { useSeo } from "../../hooks/useSeo";
import { articles, channels, tags, trending, channelName } from "../../mocks/chigua";
import ArticleCard from "../../components/feature/ArticleCard";
import FAQAccordion from "../../components/feature/FAQAccordion";
import TickerBar from "./components/TickerBar";

const findArticle = (id: string) => articles.find((a) => a.id === id);

function Chip({ children }: { children: React.ReactNode }) {
  return (
    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">{children}</span>
  );
}

export default function Home() {
  useSeo({
    title: "今天吃瓜｜今日爆料 吃瓜合集 最新瓜速览",
    description:
      "今天吃瓜今日爆料专区，聚合娱乐八卦与社会热点吃瓜帖，提供今日爆料合集与最新瓜料速览，帮你第一时间掌握今天有什么新瓜、哪些爆料正在发酵。",
    keywords: "今天吃瓜,今日爆料,吃瓜爆料合集,最新爆料,爆料汇总",
    path: "/",
    schemas: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "今天吃瓜",
        url: "https://emotechai.cn/",
        logo: "https://emotechai.cn/logo.png",
        contactPoint: { "@type": "ContactPoint", email: "gossip@jintianchigua.com", contactType: "customer support" },
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "今天吃瓜 - 今日吃瓜爆料速览",
        url: "https://emotechai.cn/",
        inLanguage: "zh-CN",
        isPartOf: { "@type": "WebSite", name: "今天吃瓜", url: "https://emotechai.cn/" },
      },
    ],
  });

  const featured = findArticle(trending[0].id)!;
  const grid = articles.slice(0, 6);
  const rows = articles.slice(6, 12);

  return (
    <>
      <TickerBar />

      {/* Masthead */}
      <section className="relative overflow-hidden border-b border-background-200">
        <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-secondary-100/70 blur-2xl" aria-hidden="true" />
        <div className="pointer-events-none absolute -bottom-24 -left-20 h-64 w-64 rounded-full bg-primary-100/60 blur-2xl" aria-hidden="true" />
        <div className="relative mx-auto grid max-w-7xl items-center gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.6fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-flashlight-fill" aria-hidden="true" />
              今日吃瓜速览 · 吃瓜合集持续更新中
            </span>
            <h1 className="mt-5 font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
              今天吃瓜，<br className="hidden md:block" />
              看<span className="text-primary-600">今日爆料</span>如何发酵
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600">
              从娱乐八卦到社会热点、网络热议再到行业内幕，把散落各平台的最新瓜料收拢成一屏
              <strong className="font-semibold text-foreground-900">吃瓜合集</strong>。点开这里，第一时间知道今天有什么新瓜、哪些
              <strong className="font-semibold text-foreground-900">爆料汇总</strong>正在热闹。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/baoliao"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
              >
                去爆料库看最新瓜
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-quill-pen-line" aria-hidden="true" />
                我要报料投稿
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3 lg:grid-cols-1">
            {[
              { icon: "ri-newspaper-line", num: "今日新增", desc: "吃瓜话题已收录更新", tone: "primary" },
              { icon: "ri-fire-line", num: "榜单每小时", desc: "按实时热度刷新热门话题", tone: "accent" },
              { icon: "ri-team-line", num: "数十万吃瓜群众", desc: "一起蹲更新的同好们", tone: "secondary" },
            ].map((s) => (
              <div
                key={s.desc}
                className={`rounded-xl border p-4 ${
                  s.tone === "primary"
                    ? "border-primary-200 bg-primary-50"
                    : s.tone === "accent"
                    ? "border-accent-200 bg-accent-50"
                    : "border-secondary-200 bg-secondary-50"
                }`}
              >
                <div className="flex items-center gap-2">
                  <i
                    className={`text-lg ${
                      s.tone === "primary" ? "ri-douban-line text-primary-500" : s.tone === "accent" ? "ri-fire-fill text-accent-500" : "ri-team-line text-secondary-600"
                    }`}
                    aria-hidden="true"
                  />
                  <span className="font-heading text-lg font-black text-foreground-950">{s.num}</span>
                </div>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured + hot rank */}
      <section className="mx-auto grid max-w-7xl gap-6 px-4 py-10 md:px-6 lg:grid-cols-[1.9fr_1fr]">
        <article className="group relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-2xl md:min-h-[380px]">
          <img src={featured.image} alt={featured.title} className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/10" />
          <div className="relative p-6 md:p-8">
            <div className="mb-3 flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">今日头瓜</span>
              <span className="rounded-md bg-background-50/15 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                {channelName(featured.channel)}
              </span>
            </div>
            <h2 className="max-w-3xl font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              <Link to={`/baoliao/${featured.id}`} className="hover:underline">
                {featured.title}
              </Link>
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-50/85">{featured.summary}</p>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-50/80">
              <span className="flex items-center gap-1"><i className="ri-time-line" />{featured.time}</span>
              <span className="flex items-center gap-1"><i className="ri-eye-line" />{featured.views} 围观</span>
              <span className="flex items-center gap-1"><i className="ri-chat-3-line" />{featured.comments} 评论</span>
            </div>
          </div>
        </article>

        <div className="flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-5">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-fire-line text-accent-500" aria-hidden="true" />
              今日热瓜榜
            </h2>
            <Link to="/baoliao" className="text-xs font-medium text-primary-600 hover:text-primary-700">查看全部 ›</Link>
          </div>
          <ol className="flex flex-1 flex-col justify-between gap-2">
            {trending.slice(0, 5).map((t) => {
              const a = findArticle(t.id)!;
              return (
                <li key={t.id}>
                  <Link
                    to={`/baoliao/${t.id}`}
                    className="group flex items-start gap-3 rounded-lg px-1 py-1.5 transition hover:bg-background-50"
                  >
                    <span
                      className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                        t.rank === 1
                          ? "bg-accent-500 text-background-50"
                          : t.rank === 2
                          ? "bg-secondary-500 text-background-50"
                          : t.rank === 3
                          ? "bg-secondary-300 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {t.rank}
                    </span>
                    <div className="min-w-0">
                      <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 group-hover:text-primary-700">
                        {a.title}
                      </p>
                      <p className="mt-1 text-[11px] text-foreground-500">{t.heat} · {a.comments} 讨论</p>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>
      </section>

      {/* Channels */}
      <section className="border-y border-background-200 bg-background-100/50">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
          <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
            <div>
              <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
                <i className="ri-grid-fill" aria-hidden="true" /> 吃瓜频道
              </p>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950">按你喜欢的方向，追不同的瓜</h2>
            </div>
            <Link to="/baoliao" className="text-sm font-medium text-primary-600 hover:text-primary-700">进入爆料库 ›</Link>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {channels.map((c) => (
              <Link
                key={c.key}
                to={`/baoliao?channel=${c.key}`}
                className="group relative overflow-hidden rounded-xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-0.5 hover:border-accent-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition group-hover:bg-primary-600">
                  <i className={`${c.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <p className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span>{c.tagline}</span>
                  <i className="ri-arrow-right-s-line text-lg transition group-hover:translate-x-0.5 group-hover:text-primary-600" aria-hidden="true" />
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest grid */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <i className="ri-flashlight-fill" aria-hidden="true" /> 实时更新
            </p>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950">最新吃瓜爆料合集</h2>
          </div>
          <Link to="/baoliao" className="rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-700">
            查看更多爆料
          </Link>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {grid.map((a) => (
            <ArticleCard key={a.id} article={a} layout="card" />
          ))}
        </div>
      </section>

      {/* More rows + about teaser */}
      <section className="border-y border-background-200 bg-background-100/50">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 md:px-6 lg:grid-cols-[1.7fr_1fr]">
          <div>
            <div className="mb-5 flex items-end justify-between">
              <div>
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
                  <i className="ri-focus-3-line" aria-hidden="true" /> 深度追踪
                </p>
                <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950">这些瓜，值得跟进一下</h2>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              {rows.map((a) => (
                <ArticleCard key={a.id} article={a} layout="row" />
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-6">
            <div className="rounded-2xl bg-primary-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-question-line rounded bg-accent-500 p-1 text-background-50" aria-hidden="true" />
                吃瓜提醒
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                吃瓜图个热闹，但也要守住分寸。站内内容多为对公开网络热议信息的整理呈现，未经证实的
                <strong className="text-primary-700">爆料</strong>请勿急着「盖棺定论」。
              </p>
              <div className="mt-4 flex flex-col gap-2 text-sm">
                {["不信谣不传谣，先看官方口径", "对事不对人，理性表达观点", "遇到反转再反转，平常心就好"].map((t) => (
                  <p key={t} className="flex items-start gap-2 text-foreground-700">
                    <i className="ri-checkbox-circle-line mt-0.5 text-accent-500" aria-hidden="true" />
                    {t}
                  </p>
                ))}
              </div>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">热门标签</h2>
              <div className="mt-4 flex flex-wrap gap-2">
                {tags.slice(0, 10).map((t) => (
                  <Link
                    key={t}
                    to={`/baoliao?q=${encodeURIComponent(t)}`}
                    className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition hover:bg-secondary-500 hover:text-background-50"
                  >
                    #{t}
                  </Link>
                ))}
              </div>
              <Link to="/about" className="mt-5 flex items-center justify-between rounded-xl bg-foreground-950 px-4 py-3 text-sm text-background-50 transition hover:bg-foreground-800">
                <span>关于「今天吃瓜」，一篇讲清楚</span>
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </aside>
        </div>
      </section>

      {/* FAQ + CTA */}
      <section className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:px-6 lg:grid-cols-[1fr_1.3fr]">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
            <i className="ri-question-answer-line" aria-hidden="true" /> 常见疑问
          </p>
          <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950">关于吃瓜，你可能想问</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            爆料真假如何判断？内容侵权怎么处理？想投稿报料找谁？关于本站与吃瓜的常见问题都整理在这里。
          </p>
          <Link to="/faq" className="mt-5 inline-flex items-center gap-2 rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-secondary-600">
            查看全部 FAQ
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
          <div className="mt-8 rounded-2xl bg-accent-500 p-6 text-background-50">
            <h2 className="font-heading text-xl font-black">手上有新鲜瓜料？</h2>
            <p className="mt-2 text-sm leading-relaxed text-background-50/90">欢迎投稿报料，编辑会认真阅读每一份来稿，信息一经采用即进入爆料库。</p>
            <Link to="/contact" className="mt-4 inline-flex items-center gap-2 rounded-md bg-background-50 px-5 py-2.5 text-sm font-bold text-accent-600 transition hover:bg-accent-50">
              <i className="ri-quill-pen-line" aria-hidden="true" />
              去报料
            </Link>
          </div>
        </div>
        <FAQAccordion limit={3} />
      </section>
    </>
  );
}